import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "/workspace/node_modules/@babel/runtime/helpers/esm/toArray";
import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ethers } from 'ethers';
import { addressesEqual, includesAddress, ANY_ENTITY } from '../address';
import { isFullMethodSignature } from '../app';
import { encodeCallScript } from '../callScript';
import { canForward } from '../forwarding';
import { createDirectTransactionForApp, createForwarderTransactionBuilder, buildForwardingFeePretransaction } from '../transactions';

function validateMethod(destination, methodSignature, destinationApp) {
  var methods = destinationApp.intents;

  if (!methods) {
    throw new Error("No functions specified in artifact for ".concat(destination));
  } // Find the relevant method information


  var method = methods.find(function (method) {
    return isFullMethodSignature(methodSignature) ? method.sig === methodSignature : // If the full signature isn't given, just select the first overload declared
    method.sig.split('(')[0] === methodSignature;
  });

  if (!method) {
    throw new Error("No method named ".concat(methodSignature, " on ").concat(destination));
  }

  return method;
}
/**
 * Calculate the forwarding path for a transaction to `destination`
 * that invokes `directTransaction`.
 *
 */


function calculateForwardingPath(_x, _x2, _x3, _x4, _x5) {
  return _calculateForwardingPath.apply(this, arguments);
}
/**
 * Calculate the transaction path for a transaction to `destination`
 * that invokes `methodSignature` with `params`.
 *
 */


function _calculateForwardingPath() {
  _calculateForwardingPath = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(sender, directTransaction, forwardersWithPermission, forwarders, provider) {
    var createForwarderTransaction, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, forwarder, script, transaction, forwardingFeePretransaction, filterForwarders, queue, _loop, _ret;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(forwardersWithPermission.length === 0)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", {
              path: []
            });

          case 2:
            createForwarderTransaction = createForwarderTransactionBuilder(sender, directTransaction); // Check if one of the forwarders that has permission to perform an action
            // with `sig` on `address` can forward for us directly

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context2.prev = 6;
            _iterator = forwardersWithPermission[Symbol.iterator]();

          case 8:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context2.next = 28;
              break;
            }

            forwarder = _step.value;
            script = encodeCallScript([directTransaction]);
            _context2.next = 13;
            return canForward(forwarder, sender, script, provider);

          case 13:
            if (!_context2.sent) {
              _context2.next = 25;
              break;
            }

            transaction = createForwarderTransaction(forwarder, script);
            _context2.prev = 15;
            _context2.next = 18;
            return buildForwardingFeePretransaction(transaction, provider);

          case 18:
            forwardingFeePretransaction = _context2.sent;
            return _context2.abrupt("return", {
              forwardingFeePretransaction: forwardingFeePretransaction,
              path: [transaction, directTransaction]
            });

          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](15);
            return _context2.abrupt("return", {
              path: []
            });

          case 25:
            _iteratorNormalCompletion = true;
            _context2.next = 8;
            break;

          case 28:
            _context2.next = 34;
            break;

          case 30:
            _context2.prev = 30;
            _context2.t1 = _context2["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 34:
            _context2.prev = 34;
            _context2.prev = 35;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 37:
            _context2.prev = 37;

            if (!_didIteratorError) {
              _context2.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context2.finish(37);

          case 41:
            return _context2.finish(34);

          case 42:
            // Get a list of all forwarders (excluding the forwarders with direct permission)
            filterForwarders = forwarders.filter(function (forwarder) {
              return !includesAddress(forwardersWithPermission, forwarder);
            }); // Set up the path finding queue
            // The queue takes the form of Array<[Array<EthereumTransaction>, Array<String>]>
            // In other words: it is an array of tuples, where the first index of the tuple
            // is the current path and the second index of the tuple is the
            // queue (a list of unexplored forwarder addresses) for that path

            queue = forwardersWithPermission.map(function (forwarderWithPermission) {
              // TODO: Fix types (type queue = [DirectTransaction[], string[]][])
              return [[createForwarderTransaction(forwarderWithPermission, encodeCallScript([directTransaction])), directTransaction], filterForwarders];
            }); // Find the shortest path via a breadth-first search of forwarder paths.
            // We do a breadth-first instead of depth-first search because:
            //   - We assume that most forwarding paths will be quite short, so it should be faster
            //     to check in "stages" rather than exhaust single paths
            //   - We don't currently protect against cycles in the path, and so exhausting single
            //     paths can be wasteful if they result in dead ends
            // TODO: We should find and return multiple paths

            _loop =
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _loop() {
              var _queue$shift, _queue$shift2, path, _queue$shift2$, forwarder, nextQueue, previousForwarder, script, _transaction, _forwardingFeePretransaction;

              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _queue$shift = queue.shift(), _queue$shift2 = _slicedToArray(_queue$shift, 2), path = _queue$shift2[0], _queue$shift2$ = _toArray(_queue$shift2[1]), forwarder = _queue$shift2$[0], nextQueue = _queue$shift2$.slice(1); // Skip if no forwarder or the path is longer than 5

                      if (!(!forwarder || path.length > 5)) {
                        _context.next = 3;
                        break;
                      }

                      return _context.abrupt("return", "continue");

                    case 3:
                      // Get the previous forwarder address
                      previousForwarder = path[0].to; // Encode the previous transaction into an EVM callscript

                      script = encodeCallScript([path[0]]);
                      _context.next = 7;
                      return canForward(previousForwarder, forwarder, script, provider);

                    case 7:
                      if (!_context.sent) {
                        _context.next = 25;
                        break;
                      }

                      _context.next = 10;
                      return canForward(forwarder, sender, script, provider);

                    case 10:
                      if (!_context.sent) {
                        _context.next = 24;
                        break;
                      }

                      // The previous forwarder can forward a transaction for this forwarder,
                      // and this forwarder can forward for our address, so we have found a path
                      _transaction = createForwarderTransaction(forwarder, script); // Only apply pretransactions to the first transaction in the path
                      // as it's the only one that will be executed by the user

                      _context.prev = 12;
                      _context.next = 15;
                      return buildForwardingFeePretransaction(_transaction, provider);

                    case 15:
                      _forwardingFeePretransaction = _context.sent;
                      return _context.abrupt("return", {
                        v: {
                          forwardingFeePretransaction: _forwardingFeePretransaction,
                          path: [_transaction].concat(_toConsumableArray(path))
                        }
                      });

                    case 19:
                      _context.prev = 19;
                      _context.t0 = _context["catch"](12);
                      return _context.abrupt("return", {
                        v: {
                          path: []
                        }
                      });

                    case 22:
                      _context.next = 25;
                      break;

                    case 24:
                      // The previous forwarder can forward a transaction for this forwarder,
                      // but this forwarder can not forward for our address, so we add it as a
                      // possible path in the queue for later exploration.
                      queue.push([[createForwarderTransaction(forwarder, script)].concat(_toConsumableArray(path)), // Avoid including the current forwarder as a candidate for the next step
                      // in the path. Note that this is naive and may result in repeating cycles,
                      // but the maximum path length would prevent against infinite loops
                      forwarders.filter(function (nextForwarder) {
                        return nextForwarder !== forwarder;
                      })]);

                    case 25:
                      // We add the current path on the back of the queue again, but we shorten
                      // the list of possible forwarders.
                      queue.push([path, nextQueue]);

                    case 26:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop, null, [[12, 19]]);
            });

          case 45:
            return _context2.delegateYield(_loop(), "t2", 46);

          case 46:
            _ret = _context2.t2;
            _context2.t3 = _ret;
            _context2.next = _context2.t3 === "continue" ? 50 : 51;
            break;

          case 50:
            return _context2.abrupt("continue", 53);

          case 51:
            if (!(typeof _ret === "object")) {
              _context2.next = 53;
              break;
            }

            return _context2.abrupt("return", _ret.v);

          case 53:
            if (queue.length) {
              _context2.next = 45;
              break;
            }

          case 54:
            return _context2.abrupt("return", {
              path: []
            });

          case 55:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[6, 30, 34, 42], [15, 22], [35,, 37, 41]]);
  }));
  return _calculateForwardingPath.apply(this, arguments);
}

export function calculateTransactionPath(_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
  return _calculateTransactionPath.apply(this, arguments);
}

function _calculateTransactionPath() {
  _calculateTransactionPath = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(sender, destination, methodSignature, params, apps, provider, finalForwarder //Address of the final forwarder that can perfom the action. Needed for actions that aren't in the ACL but whose execution depends on other factors
  ) {
    var _a, destinationApp, method, finalForwarderProvided, directTransaction, forwarders, forwardersWithPermission, role, allowedEntities;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // Get the destination app
            destinationApp = apps.find(function (app) {
              return app.address == destination;
            });

            if (destinationApp) {
              _context3.next = 3;
              break;
            }

            throw new Error("Transaction path destination (".concat(destination, ") is not an installed app"));

          case 3:
            // Make sure the method signature is correct
            method = validateMethod(destination, methodSignature, destinationApp);
            finalForwarderProvided = finalForwarder ? ethers.utils.isAddress(finalForwarder) : false;
            _context3.next = 7;
            return createDirectTransactionForApp(sender, destinationApp, method.sig, params);

          case 7:
            directTransaction = _context3.sent;

            if (!(method.roles.length === 0 && !finalForwarderProvided || finalForwarder && addressesEqual(finalForwarder, sender))) {
              _context3.next = 16;
              break;
            }

            _context3.prev = 9;
            return _context3.abrupt("return", {
              path: [directTransaction]
            });

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](9);
            return _context3.abrupt("return", {
              path: []
            });

          case 16:
            // Failing this, attempt transaction pathing algorithm with forwarders
            forwarders = apps.filter(function (app) {
              return app.isForwarder === true;
            }).map(function (app) {
              return app.address;
            });
            forwardersWithPermission = [];

            if (!finalForwarderProvided) {
              _context3.next = 25;
              break;
            }

            if (!finalForwarder) {
              _context3.next = 23;
              break;
            }

            if (includesAddress(forwarders, finalForwarder)) {
              _context3.next = 22;
              break;
            }

            return _context3.abrupt("return", {
              path: []
            });

          case 22:
            // Only attempt to find path with declared final forwarder; assume the final forwarder
            // is able to invoke the action
            forwardersWithPermission = [finalForwarder];

          case 23:
            _context3.next = 40;
            break;

          case 25:
            _context3.next = 27;
            return destinationApp.roles();

          case 27:
            _context3.t1 = function (role) {
              return role.name === method.roles[0];
            };

            role = _context3.sent.find(_context3.t1);
            allowedEntities = ((_a = role === null || role === void 0 ? void 0 : role.permissions) === null || _a === void 0 ? void 0 : _a.map(function (permission) {
              return permission.granteeAddress;
            })) || []; // No one has access, so of course we don't as well

            if (!(allowedEntities.length === 0)) {
              _context3.next = 32;
              break;
            }

            return _context3.abrupt("return", {
              path: []
            });

          case 32:
            if (!(includesAddress(allowedEntities, sender) || includesAddress(allowedEntities, ANY_ENTITY))) {
              _context3.next = 39;
              break;
            }

            _context3.prev = 33;
            return _context3.abrupt("return", {
              path: [directTransaction]
            });

          case 37:
            _context3.prev = 37;
            _context3.t2 = _context3["catch"](33);

          case 39:
            // Find forwarders with permission to perform the action
            forwardersWithPermission = forwarders.filter(function (forwarder) {
              return includesAddress(allowedEntities, forwarder);
            });

          case 40:
            return _context3.abrupt("return", calculateForwardingPath(sender, directTransaction, forwardersWithPermission, forwarders, provider));

          case 41:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[9, 13], [33, 37]]);
  }));
  return _calculateTransactionPath.apply(this, arguments);
}